module.exports = __webpack_public_path__ + "static/media/HCMM625.6c70c8e2.jpg";